import React from 'react'
import psLogo from '../asset/ps_appicon.png';

export default function AdobeLogo () {
    return <div className='adobe-menu-top'>
        <div>
        <img className="adobe-logo" src={psLogo} width="50px" height="50px" alt="Adobe, Inc."></img>
        </div>
        <div>
            <div className='adobe-title'>
                Photoshop API SDK
            </div>
            <div className='adobe-title'>
                (Beta)
            </div>
        </div>
    </div>
}